var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c("CompassPanel", {
        staticClass: "activity-detail-panel",
        attrs: {
          title: _vm.panelTitle,
          icon: _vm.panelIcon,
          value: true,
          headerActions: _vm.headerActions
        },
        on: { beforeClose: _vm.onClosePanel },
        scopedSlots: _vm._u(
          [
            {
              key: "header-suffix",
              fn: function() {
                return [
                  _vm.isActivityLate &&
                  _vm.fetchingStatus === _vm.fetchingStatusEnum.success
                    ? _c("BadgeActivityStatus", {
                        attrs: {
                          tag: {
                            type: "error",
                            label: _vm.localizedTexts.isLateLabel
                          }
                        }
                      })
                    : _vm._e()
                ]
              },
              proxy: true
            },
            {
              key: "default",
              fn: function() {
                return [
                  _vm.fetchingStatus === _vm.fetchingStatusEnum.loading
                    ? _c(
                        "div",
                        [_c("ActivityDetailPanelContentLoadingState")],
                        1
                      )
                    : _vm.fetchingStatus === _vm.fetchingStatusEnum.error
                    ? _c("CompassAlert", {
                        attrs: {
                          type: "error",
                          description: _vm.localizedTexts.errorAlertLabel,
                          showClose: false
                        }
                      })
                    : _vm.fetchingStatus === _vm.fetchingStatusEnum.success
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "activity-detail-panel__general-information"
                            },
                            [
                              !_vm.isActivityPhonecall
                                ? _c(
                                    "CompassDescriptionList",
                                    { attrs: { type: "alternative" } },
                                    [
                                      _c(
                                        "CompassDescriptionListItem",
                                        {
                                          attrs: {
                                            label: _vm.$t.__(
                                              "common.labels.title"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "typographies-paragraph-medium-semibold"
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(_vm.activityTitle) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "CompassDescriptionList",
                                { attrs: { type: "alternative" } },
                                [
                                  _vm.activityDetailData.priority >= 0
                                    ? _c(
                                        "CompassDescriptionListItem",
                                        {
                                          attrs: {
                                            label:
                                              _vm.localizedTexts
                                                .descriptionListLabel.priority
                                          }
                                        },
                                        [
                                          _c("ActivitiesPriorityIconButton", {
                                            attrs: {
                                              isActive:
                                                _vm.activityDetailData
                                                  .priority > 0,
                                              isPending: _vm.isPriorityPending,
                                              enabled:
                                                _vm.activityDetailData._embed
                                                  .acl.can_be_updated,
                                              dataBot:
                                                "activity-detail-panel__priority-icon-button"
                                            },
                                            on: { clicked: _vm.updatePriority }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "CompassDescriptionList",
                                { attrs: { type: "alternative" } },
                                [
                                  _vm.label && _vm.label.is_active
                                    ? _c(
                                        "CompassDescriptionListItem",
                                        {
                                          attrs: {
                                            label:
                                              _vm.localizedTexts
                                                .descriptionListLabel.label
                                          }
                                        },
                                        [
                                          _c(
                                            "CompassTag",
                                            {
                                              attrs: {
                                                type: "dot",
                                                color: "custom",
                                                customColor: _vm.label.color
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(_vm.label.name) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.shouldDisplayDateItem
                                    ? _c(
                                        "CompassDescriptionListItem",
                                        {
                                          attrs: {
                                            label:
                                              _vm.localizedTexts
                                                .descriptionListLabel.date
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "activity-detail-panel__general-information-date"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "activity-detail-panel__calendar-icon-wrapper"
                                                },
                                                [
                                                  _c("CompassIcon", {
                                                    attrs: {
                                                      icon: "calendar-fill",
                                                      size: "small"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.shouldDisplayRangeDate
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "activity-detail-panel__general-information-date-range"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "typographies-paragraph-medium-regular"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                    " +
                                                              _vm._s(
                                                                _vm.$l10n.__(
                                                                  "du %s",
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .activityDetailData
                                                                      .datetime_start
                                                                  )
                                                                )
                                                              ) +
                                                              "\n                                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "typographies-paragraph-medium-regular"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                    " +
                                                              _vm._s(
                                                                _vm.$l10n.__(
                                                                  "au %s",
                                                                  _vm.formatDate(
                                                                    _vm
                                                                      .activityDetailData
                                                                      .datetime_end
                                                                  )
                                                                )
                                                              ) +
                                                              "\n                                "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          _vm.formattedDueDate
                                                        ) +
                                                        "\n                            "
                                                    )
                                                  ])
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.shouldDisplayEventContacts
                                    ? _c(
                                        "CompassDescriptionListItem",
                                        {
                                          staticClass:
                                            "participants-avatar-text activity-detail-panel__general-information--stacked_element",
                                          attrs: {
                                            label:
                                              _vm.localizedTexts
                                                .descriptionListLabel.contacts
                                          }
                                        },
                                        [
                                          _vm._l(
                                            _vm.assignedContactsFiltered.slice(
                                              0,
                                              _vm.maxContactsToDisplay
                                            ),
                                            function(contact) {
                                              return _c(
                                                "div",
                                                { key: contact.id },
                                                [
                                                  contact.type === "contact"
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "CompassAvatarName",
                                                            {
                                                              attrs: {
                                                                size: "small",
                                                                firstname: _vm.getFirstName(
                                                                  contact.contactInfo
                                                                ),
                                                                lastname: _vm.getLastName(
                                                                  contact.contactInfo
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "CompassAvatar",
                                                                {
                                                                  attrs: {
                                                                    initials: _vm.getInitials(
                                                                      contact.contactInfo
                                                                    ),
                                                                    photo:
                                                                      contact
                                                                        .contactInfo
                                                                        .avatar,
                                                                    size:
                                                                      "small",
                                                                    colorType: _vm.getAvatarColor(
                                                                      contact
                                                                    )
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "typographies-paragraph-medium-semibold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                contact.id
                                                              ) +
                                                              "\n                            "
                                                          )
                                                        ]
                                                      )
                                                ]
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm.assignedContactsFiltered.length >
                                          _vm.maxContactsToDisplay
                                            ? [
                                                _c("CompassPlainButton", {
                                                  ref:
                                                    "buttonDisplayPopoverAssignee",
                                                  staticClass:
                                                    "activity-detail-panel__general-information--assigned-staffs__button-more",
                                                  attrs: {
                                                    label:
                                                      _vm.labelMoreContactsBtn,
                                                    type: "tertiary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.isPopoverAssigneeDisplayed = true
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "CompassPopover",
                                                  {
                                                    attrs: {
                                                      isVisible:
                                                        _vm.isPopoverAssigneeDisplayed,
                                                      triggerRef:
                                                        "buttonDisplayPopoverAssignee",
                                                      customClass:
                                                        "activity-detail-panel__general-information--assigned-contacts__menu-more",
                                                      placement: "bottom-start"
                                                    },
                                                    on: {
                                                      close: function($event) {
                                                        _vm.isPopoverAssigneeDisplayed = false
                                                      }
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.assignedContactsFiltered.slice(
                                                      _vm.maxContactsToDisplay,
                                                      _vm
                                                        .assignedContactsFiltered
                                                        .length
                                                    ),
                                                    function(contact) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: contact.id,
                                                          staticClass:
                                                            "menu-more__item participants-avatar-text"
                                                        },
                                                        [
                                                          contact.type ===
                                                          "contact"
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "CompassAvatarName",
                                                                    {
                                                                      attrs: {
                                                                        size:
                                                                          "small",
                                                                        firstname: _vm.getFirstName(
                                                                          contact.contactInfo
                                                                        ),
                                                                        lastname: _vm.getLastName(
                                                                          contact.contactInfo
                                                                        ),
                                                                        showCaption: false
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "CompassAvatar",
                                                                        {
                                                                          attrs: {
                                                                            initials: _vm.getInitials(
                                                                              contact.contactInfo
                                                                            ),
                                                                            size:
                                                                              "small",
                                                                            colorType: _vm.getAvatarColor(
                                                                              contact
                                                                            ),
                                                                            photo:
                                                                              contact
                                                                                .contactInfo
                                                                                .avatar
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "typographies-paragraph-medium-semibold"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                        " +
                                                                      _vm._s(
                                                                        contact.id
                                                                      ) +
                                                                      "\n                                    "
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.owner
                                    ? _c(
                                        "CompassDescriptionListItem",
                                        {
                                          attrs: {
                                            label: _vm.$t.__(
                                              "common.labels.assignee"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "CompassAvatarName",
                                            {
                                              attrs: {
                                                size: "small",
                                                firstname: _vm.owner.firstname,
                                                lastname: _vm.owner.lastname
                                              }
                                            },
                                            [
                                              _c("CompassAvatar", {
                                                attrs: {
                                                  initials:
                                                    "" +
                                                    _vm.owner.firstname[0] +
                                                    _vm.owner.lastname[0],
                                                  photo: _vm.owner.avatar,
                                                  size: "small",
                                                  colorType: _vm.getAvatarColor(
                                                    _vm.owner
                                                  ),
                                                  stateBadge: _vm.getStateStaff(
                                                    _vm.owner
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.assignedStaffsFiltered.length > 0
                                    ? _c(
                                        "CompassDescriptionListItem",
                                        {
                                          staticClass:
                                            "activity-detail-panel__general-information--assigned-staffs participants-avatar-text activity-detail-panel__general-information--stacked_element",
                                          attrs: {
                                            label: _vm.$t.__(
                                              "common.labels.select_other_staff"
                                            )
                                          }
                                        },
                                        [
                                          _vm._l(
                                            _vm.assignedStaffsFiltered.slice(
                                              0,
                                              _vm.maxStaffToDisplay
                                            ),
                                            function(staff) {
                                              return _c(
                                                "CompassAvatarName",
                                                {
                                                  key: staff.id,
                                                  attrs: {
                                                    size: "small",
                                                    firstname: staff.firstname,
                                                    lastname: staff.lastname
                                                  }
                                                },
                                                [
                                                  _c("CompassAvatar", {
                                                    attrs: {
                                                      initials:
                                                        "" +
                                                        staff.firstname[0] +
                                                        staff.lastname[0],
                                                      photo: staff.avatar,
                                                      size: "small",
                                                      colorType: _vm.getAvatarColor(
                                                        staff
                                                      ),
                                                      stateBadge: _vm.getStateStaff(
                                                        staff
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm.assignedStaffsFiltered.length >
                                          _vm.maxStaffToDisplay
                                            ? [
                                                _c("CompassPlainButton", {
                                                  ref:
                                                    "buttonDisplayPopoverAssignee",
                                                  staticClass:
                                                    "activity-detail-panel__general-information--assigned-staffs__button-more",
                                                  attrs: {
                                                    label:
                                                      _vm.labelMoreStaffsBtn,
                                                    type: "tertiary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.isPopoverAssigneeDisplayed = true
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "CompassPopover",
                                                  {
                                                    attrs: {
                                                      isVisible:
                                                        _vm.isPopoverAssigneeDisplayed,
                                                      triggerRef:
                                                        "buttonDisplayPopoverAssignee",
                                                      customClass:
                                                        "activity-detail-panel__general-information--assigned-staffs__menu-more",
                                                      placement: "bottom-start"
                                                    },
                                                    on: {
                                                      close: function($event) {
                                                        _vm.isPopoverAssigneeDisplayed = false
                                                      }
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.assignedStaffsFiltered.slice(
                                                      _vm.maxStaffToDisplay,
                                                      _vm.assignedStaffsFiltered
                                                        .length
                                                    ),
                                                    function(staff) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: staff.id,
                                                          staticClass:
                                                            "menu-more__item"
                                                        },
                                                        [
                                                          _c("CompassAvatar", {
                                                            attrs: {
                                                              size: "small",
                                                              photo:
                                                                staff.avatar,
                                                              initials:
                                                                "" +
                                                                staff
                                                                  .firstname[0] +
                                                                staff
                                                                  .lastname[0],
                                                              colorType: _vm.getAvatarColor(
                                                                staff
                                                              )
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "typographies-paragraph-medium-regular"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                        " +
                                                                  _vm._s(
                                                                    staff.firstname
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    staff.lastname
                                                                  ) +
                                                                  "\n                                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.shouldDisplayDescriptionEventTask
                                ? _c("ActivityDetailDescriptionComponent", {
                                    attrs: {
                                      text: _vm.activityDetailData.description,
                                      label:
                                        _vm.localizedTexts.descriptionListLabel
                                          .description
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isActivityPhonecall
                                ? [
                                    _c(
                                      "CompassDescriptionList",
                                      {
                                        staticClass:
                                          "activity-detail-panel__general-information-phonecall"
                                      },
                                      [
                                        _vm.activityDetailData.duration
                                          ? _c(
                                              "CompassDescriptionListItem",
                                              {
                                                attrs: {
                                                  label:
                                                    _vm.localizedTexts
                                                      .descriptionListLabel
                                                      .phoneCall.duration
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.phoneCallDuration
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.activityDetailData.result
                                          ? _c(
                                              "CompassDescriptionListItem",
                                              {
                                                attrs: {
                                                  label:
                                                    _vm.localizedTexts
                                                      .descriptionListLabel
                                                      .phoneCall.result
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.activityDetailData
                                                        .result.name
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.activityDetailData.description
                                      ? _c(
                                          "ActivityDetailDescriptionComponent",
                                          {
                                            attrs: {
                                              text:
                                                _vm.activityDetailData
                                                  .description,
                                              label: _vm.$t.__(
                                                "common.labels.note"
                                              )
                                            }
                                          }
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          !_vm.isEmpty(_vm.relatedData)
                            ? [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "typographies-heading-h3 activity-detail-panel__related-object--title"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.localizedTexts
                                            .descriptionListLabel.related
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "activity-detail-panel__related-object"
                                  },
                                  [
                                    _vm.isRelatedTypeContact &&
                                    _vm.relatedData.contact
                                      ? _c("ActivityDetailLinkedContact", {
                                          attrs: { data: _vm.relatedData }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isRelatedTypeCompany &&
                                    _vm.relatedData.company
                                      ? _c("ActivityDetailLinkedCompany", {
                                          attrs: {
                                            data: _vm.relatedData,
                                            showContactSlot: !_vm.isActivityPhonecall
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isRelatedTypeOpporunity &&
                                    _vm.relatedData.opportunity
                                      ? _c("ActivityDetailLinkedOpportunity", {
                                          attrs: {
                                            showContactSlot: !_vm.isActivityPhonecall,
                                            data: _vm.relatedData
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isRelatedTypeDocument &&
                                    _vm.relatedData.document
                                      ? _c("ActivityDetailLinkedDoc", {
                                          attrs: { data: _vm.relatedData }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            },
            {
              key: "footer",
              fn: function() {
                return [
                  _vm.fetchingStatus === _vm.fetchingStatusEnum.success &&
                  _vm.canUpdateStatusOrReschedule
                    ? _c("ActivityPanelDetailsPanelFooter", {
                        attrs: {
                          activityDate: _vm.rescheduleDatePickerValue,
                          isDone: _vm.activityIsDone,
                          pending: _vm.isFooterPending,
                          canReschedule: !_vm.activityIsDone,
                          canBeUpdated:
                            _vm.activityDetailData._embed.acl.can_be_updated,
                          isReschedulePending: _vm.isReschedulePending,
                          hasDropdown: !_vm.isActivityPhonecall
                        },
                        on: {
                          updateStatus: _vm.updateStatus,
                          updateDueDate: _vm.updateDueDate
                        }
                      })
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          3271878074
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }